define('post-editor/sidebar-api',['tinymce/ui/Panel', 'tinymce/EditorManager', 'lib/array.generics'],
function(Panel, EditorManager, _) {
	/**
	 * A hash of hashes. groupsForElements.elementName.className,
	 * or groupsForElements.elementName['_'] if no class is required
	 */
	var groupsForElements = {};
	
	function preprocessUIElement(def) {
		if ('cmd' in def) {
			def.onclick = function() {
				if (EditorManager.activeEditor)
					EditorManager.activeEditor.execCommand(def.cmd);
				else
					console.log('no active editor');
			};
		}
		
		if ('items' in def) {
			def.items.forEach(function(item) {
				preprocessUIElement(item);
			});
		}
	}
	
	function preprocessGroup(def) {
		preprocessUIElement(def);
	}
	
	var api = {
		/**
		 * Defines control groups that should be displayed in the sidebar when any
		 * of the defined target elements is selected
		 * @param targetElements array of element names, or whitespace-separated string.
		 *   element names can be of form img.classname to target specific classes
		 * @param groups array of groups definitions
		 */
		defineGroups: function(targetElements, groups) {
			if (!(targetElements instanceof Array))
				targetElements = targetElements.match(/[^ ]+/g);
			
			groups.forEach(function(group) {
				preprocessGroup(group);
			});
			
			targetElements.forEach(function(elem) {
				elem = elem.toLowerCase();
				var className = '_';
				if (elem.indexOf('.') >= 0) {
					className = elem.substr(elem.indexOf('.') + 1);
					elem = elem.substr(0, elem.indexOf('.'));
				}
				
				if (!(elem in groupsForElements))
					groupsForElements[elem] = {_: []};

				if (!(className in groupsForElements[elem]))
					groupsForElements[elem][className] = [];
				
				groupsForElements[elem][className] = 
					groupsForElements[elem][className].concat(groups);
			});
		},
		
		/**
		 * Gets the toolbox groups for the given element and its parents
		 */
		getGroupsForElement: function(element) {
			var name = element.nodeName.toLowerCase();
			var groups = [];
			var groupDefs = [];
			
			// Stores the element alongside the group definition
			function push(newGroups) {
				newGroups.forEach(function(group) {
					groups.push({
						def: group,
						element: element
					});
					groupDefs.push(group);
				});
			}
			
			// include groups that apply to all elements
			if ('*' in groupsForElements)
				push(groupsForElements['*']._);
			
			if (name in groupsForElements) {
				push(groupsForElements[name]._);
				for (className in groupsForElements[name]) {
					if ($(element).hasClass(className))
						push(groupsForElements[name][className]);
				}
			}
			
			if (element.parentNode) {
				// filter out duplicates
				groups = groups.concat(
					api.getGroupsForElement(element.parentNode)
						.filter(function(g) { return groupDefs.indexOf(g.def) < 0; }));
			} else
				groups;
			
			// Groups can hide all other groups (that are not exclusive)
			if (groups.some(function(g) { return g.def.exclusive; })) {
				groups = groups.filter(function(g) { return g.def.exclusive; });
			}
			
			return groups;
		}
	}
	
	return api;
});

